const API_HOST = (import.meta.env['VITE_API_HOST'] as string | undefined) ?? 'https://api.arrivesafe.app';

export const API_BASE = `${API_HOST}/v3`;

/**
 * Socket URL is usually the same host as the REST API. In local dev the SPA
 * runs at localhost:5173 with VITE_API_HOST empty so REST goes through Vite's
 * proxy — but Vite's WS proxy through Cloudflare is unreliable (502s). So the
 * socket connects directly to the API host. CORS is enforced server-side; if
 * the API rejects localhost the connection just stays in `offline` state.
 */
export const SOCKET_URL =
  (import.meta.env['VITE_SOCKET_URL'] as string | undefined) ||
  API_HOST ||
  'https://api.arrivesafe.app';
export const MAPTILER_KEY = (import.meta.env['VITE_MAPTILER_KEY'] as string | undefined) ?? '';
